var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { CardRarity, ImxPendingBurnStatus, SortOrderDirection, } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import { CurrencyContext } from '../../context/currency';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { CurrencyTokenSymbol } from '../../data/currency-tokens/currency-tokens';
import { appEnv } from '../../env';
import { WalletConnectionType } from '../../types/blockchain';
import { SortDirection, TokenType } from '../../types/common';
import { DialogType } from '../../types/dialogs';
import { sleep } from '../../utils/async';
import { checkIfWalletAsEnoughCurrency } from '../../utils/balances';
import { MAX_SELECTION_COUNT } from '../../utils/multi-select';
import { burnPendingBurn, splitPendingBurns } from '../../utils/pending-burns';
import { useCtaTokenRates } from '../cta-token/use-cta-token-rates';
import { useImxActions } from '../imx/use-imx-actions';
var TAKE = 200;
export var MAX_VOUCHERS_COUNT_TO_BURN = 500;
export var USER_LEVEL_REQUIRED = 10;
export function useMyAssetsFlex(filters) {
    var t = useI18n().t;
    var _a = useContext(LoadingContext), setServerLoading = _a.setServerLoading, setImxLoading = _a.setImxLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _b = useContext(UserContext), user = _b.user, selectedWallet = _b.selectedWallet, balances = _b.balances, localWalletAddress = _b.localWalletAddress, reconnectUser = _b.reconnectUser, getBalances = _b.getBalances;
    var parseCurrencyQuantity = useContext(CurrencyContext).parseCurrencyQuantity;
    var imx = useImxActions();
    var timestamp = useCtaTokenRates().timestamp;
    var _c = useState(undefined), cards = _c[0], setCards = _c[1];
    var _d = useState(undefined), presalePacks = _d[0], setPresalePacks = _d[1];
    var _e = useState(undefined), chests = _e[0], setChests = _e[1];
    var _f = useState(TAKE), take = _f[0], setTake = _f[1];
    var _g = useState(0), skip = _g[0], setSkip = _g[1];
    var _h = useState([]), selectedUuids = _h[0], setSelectedUuids = _h[1];
    var _j = useState([]), lastSelectedIndexes = _j[0], setLastSelectedIndexes = _j[1];
    var _k = useState(2), freeMintsAmount = _k[0], setFreeMintsAmount = _k[1];
    var _l = useState('0'), ctaTokenAmount = _l[0], setCtaTokenAmount = _l[1];
    var _m = useState(false), notEnoughCurrency = _m[0], setNotEnoughCurrency = _m[1];
    var _o = useState(false), previewLoading = _o[0], setPreviewLoading = _o[1];
    var _p = useState(null), previewTimeout = _p[0], setPreviewTimeout = _p[1];
    var _q = useState(0), vouchersCount = _q[0], setVouchersCount = _q[1];
    var _r = useState(0), triselsCount = _r[0], setTriselsCount = _r[1];
    var _s = useState(0), stonesCount = _s[0], setStonesCount = _s[1];
    var _t = useState(0), maxCountToSelect = _t[0], setMaxCountToSelect = _t[1];
    useEffect(function () {
        getVouchersCount();
    }, []);
    useEffect(function () {
        if (selectedUuids.length > 0) {
            setSelectedUuids([]);
        }
        var assetsCount = 0;
        if (filters.state.tokenTypes[0] === TokenType.CARD && cards) {
            assetsCount = cards.length;
        }
        else if (filters.state.tokenTypes[0] === TokenType.PRESALE_PACK && presalePacks) {
            assetsCount = presalePacks.length;
        }
        else if (filters.state.tokenTypes[0] === TokenType.CHEST && chests) {
            assetsCount = chests.length;
        }
        setMaxCountToSelect(Math.min(MAX_SELECTION_COUNT, assetsCount));
    }, [filters.state.tokenTypes, cards, presalePacks, chests]);
    useEffect(function () {
        setSelectedUuids([]);
        setLastSelectedIndexes([]);
        setCtaTokenAmount('0');
        setFreeMintsAmount(0);
        getAssets(true);
    }, [
        filters.state.tokenTypes,
        filters.state.sets,
        filters.state.advancements,
        filters.state.cardTypes,
        filters.state.factions,
        filters.state.foils,
        filters.state.grades,
        filters.state.ranks,
        filters.state.rarities,
        filters.state.searchQuery.value,
        filters.state.collections,
        filters.state.elements,
        filters.state.direction,
    ]);
    useEffect(function () {
        if (previewTimeout) {
            clearTimeout(previewTimeout);
        }
        setPreviewLoading(true);
        setPreviewTimeout(setTimeout(function () { return setPreviewLoading(false); }, 1000));
    }, [selectedUuids]);
    useEffect(function () {
        if (!previewLoading) {
            getMintPreview();
            getShredPreview();
        }
    }, [previewLoading]);
    useEffect(function () {
        var hasEnoughCurrency = checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, appEnv.ctaTokenAddress, "".concat(ctaTokenAmount, "00000000"));
        setNotEnoughCurrency(!hasEnoughCurrency);
    }, [ctaTokenAmount, user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity]);
    function getVouchersCount() {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, gqlSdk.PresaleGetVoucherCount()];
                    case 1:
                        result = _a.sent();
                        setVouchersCount(result.presaleGetVoucherCount.count);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getCards(refresh) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!refresh && take === 0)
                            return [2 /*return*/];
                        setServerLoading(true);
                        return [4 /*yield*/, gqlSdk.MpCardFindMany({
                                input: {
                                    skip: refresh ? 0 : skip,
                                    take: TAKE,
                                    sortNameOrder: filters.state.direction === SortDirection.ASC ? SortOrderDirection.ASC : SortOrderDirection.DESC,
                                    advancements: filters.state.advancements.length > 0 ? filters.state.advancements : undefined,
                                    rarities: filters.state.rarities.length > 0 ? filters.state.rarities : undefined,
                                    elements: filters.state.elements.length > 0 ? filters.state.elements : undefined,
                                    factions: filters.state.factions.length > 0 ? filters.state.factions : undefined,
                                    seasons: filters.state.collections.length > 0 ? filters.state.collections : undefined,
                                    sets: filters.state.sets.length > 0 ? filters.state.sets : undefined,
                                    foil: filters.state.foils.length === 1 ? filters.state.foils[0] : undefined,
                                    grades: filters.state.grades.length > 0 ? filters.state.grades : undefined,
                                    ranks: filters.state.ranks.length > 0 ? filters.state.ranks : undefined,
                                    types: filters.state.cardTypes.length > 0 ? filters.state.cardTypes : undefined,
                                    name: filters.state.searchQuery.value.length > 0 ? filters.state.searchQuery.value.toLowerCase() : undefined,
                                },
                            })];
                    case 1:
                        result = _a.sent();
                        setCards(cards === undefined || refresh ? result.mpCardFindMany : __spreadArray(__spreadArray([], cards, true), result.mpCardFindMany, true));
                        setPresalePacks(undefined);
                        setChests(undefined);
                        setTake(result.mpCardFindMany.length < TAKE ? 0 : TAKE);
                        setSkip(function (value) { return (refresh ? result.mpCardFindMany.length : value + result.mpCardFindMany.length); });
                        setServerLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getPresalePacks(refresh) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!refresh && take === 0)
                            return [2 /*return*/];
                        setServerLoading(true);
                        return [4 /*yield*/, gqlSdk.MpPresalePackFindMany({
                                input: {
                                    skip: refresh ? 0 : skip,
                                    take: TAKE,
                                },
                            })];
                    case 1:
                        result = _a.sent();
                        setPresalePacks(presalePacks === undefined || refresh
                            ? result.mpPresalePackFindMany
                            : __spreadArray(__spreadArray([], presalePacks, true), result.mpPresalePackFindMany, true));
                        setCards(undefined);
                        setChests(undefined);
                        setTake(result.mpPresalePackFindMany.length < TAKE ? 0 : TAKE);
                        setSkip(function (value) { return (refresh ? result.mpPresalePackFindMany.length : value + result.mpPresalePackFindMany.length); });
                        setServerLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getChests(refresh) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!refresh && take === 0)
                            return [2 /*return*/];
                        setServerLoading(true);
                        return [4 /*yield*/, gqlSdk.MpChestFindMany({
                                input: {
                                    skip: refresh ? 0 : skip,
                                    take: TAKE,
                                },
                            })];
                    case 1:
                        result = _a.sent();
                        setChests(chests === undefined || refresh ? result.mpChestFindMany : __spreadArray(__spreadArray([], chests, true), result.mpChestFindMany, true));
                        setCards(undefined);
                        setPresalePacks(undefined);
                        setTake(result.mpChestFindMany.length < TAKE ? 0 : TAKE);
                        setSkip(function (value) { return (refresh ? result.mpChestFindMany.length : value + result.mpChestFindMany.length); });
                        setServerLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function selectUuid(uuid) {
        var allAssets = undefined;
        if (filters.state.tokenTypes[0] === TokenType.CARD) {
            allAssets = cards;
        }
        else if (filters.state.tokenTypes[0] === TokenType.PRESALE_PACK) {
            allAssets = presalePacks;
        }
        else if (filters.state.tokenTypes[0] === TokenType.CHEST) {
            allAssets = chests;
        }
        var values = __spreadArray([], selectedUuids, true);
        var selectedIndexes = __spreadArray([], lastSelectedIndexes, true);
        var selectedIndex = allAssets ? allAssets.findIndex(function (value) { return value.uuid === uuid; }) : -1;
        var index = values.findIndex(function (value) { return value === uuid; });
        if (index === -1) {
            selectedIndexes.push(selectedIndex);
            values.push(uuid);
        }
        else {
            selectedIndexes.splice(selectedIndex, 1);
            values.splice(index, 1);
        }
        setLastSelectedIndexes(selectedIndexes);
        setSelectedUuids(values);
    }
    function shiftSelectAsset(index) {
        var allAssets = undefined;
        if (filters.state.tokenTypes[0] === TokenType.CARD) {
            allAssets = cards;
        }
        else if (filters.state.tokenTypes[0] === TokenType.PRESALE_PACK) {
            allAssets = presalePacks;
        }
        else if (filters.state.tokenTypes[0] === TokenType.CHEST) {
            allAssets = chests;
        }
        if (!allAssets || !allAssets[index])
            return;
        var values = __spreadArray([], selectedUuids, true);
        var selectedIndexes = __spreadArray([], lastSelectedIndexes, true);
        var lastIndex = lastSelectedIndexes.length === 0 ? -1 : lastSelectedIndexes[lastSelectedIndexes.length - 1];
        if (lastIndex === -1 || lastIndex === index) {
            selectUuid(allAssets[index].uuid);
            return;
        }
        var startIndex = lastIndex > index ? index : lastIndex;
        var endIndex = lastIndex > index ? lastIndex : index;
        var _loop_1 = function (i) {
            // @ts-ignore
            var findIndex = values.findIndex(function (value) { return value === allAssets[i].uuid; });
            if (findIndex === -1) {
                values.push(allAssets[i].uuid);
            }
        };
        for (var i = startIndex; i <= endIndex; i++) {
            _loop_1(i);
        }
        selectedIndexes.push(index);
        setSelectedUuids(values);
        setLastSelectedIndexes(selectedIndexes);
    }
    function changeAssetsSelection(count) {
        var values = [];
        var selectedIndexes = [];
        for (var i = 0; i < count; i++) {
            if (filters.state.tokenTypes[0] === TokenType.CARD && cards && cards[i]) {
                values.push(cards[i].uuid);
            }
            else if (filters.state.tokenTypes[0] === TokenType.PRESALE_PACK && presalePacks && presalePacks[i]) {
                values.push(presalePacks[i].uuid);
            }
            else if (filters.state.tokenTypes[0] === TokenType.CHEST && chests && chests[i]) {
                values.push(chests[i].uuid);
            }
        }
        setSelectedUuids(values);
        setLastSelectedIndexes(selectedIndexes);
    }
    function getAssets(refresh) {
        return __awaiter(this, void 0, void 0, function () {
            var container;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(filters.state.tokenTypes[0] === TokenType.CARD)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getCards(refresh)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(filters.state.tokenTypes[0] === TokenType.PRESALE_PACK)) return [3 /*break*/, 4];
                        return [4 /*yield*/, getPresalePacks(refresh)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        if (!(filters.state.tokenTypes[0] === TokenType.CHEST)) return [3 /*break*/, 6];
                        return [4 /*yield*/, getChests(refresh)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        if (refresh) {
                            container = window.document.getElementById('my-assets-flex-grid');
                            container === null || container === void 0 ? void 0 : container.scrollTo({ top: 0 });
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function getMintPreview() {
        return __awaiter(this, void 0, void 0, function () {
            var result, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (selectedUuids.length > MAX_SELECTION_COUNT)
                            return [2 /*return*/];
                        if (!(selectedUuids.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD)) return [3 /*break*/, 2];
                        return [4 /*yield*/, gqlSdk.CardBulkMintPreview({ input: { cardsUuids: selectedUuids, timestamp: timestamp } })];
                    case 1:
                        result = _a.sent();
                        setFreeMintsAmount(result.cardBulkMintPreview.priceInFreeMint);
                        setCtaTokenAmount(result.cardBulkMintPreview.priceInCtaTokenDeci18);
                        return [3 /*break*/, 5];
                    case 2:
                        if (!((selectedUuids.length > 0 && filters.state.tokenTypes[0] === TokenType.PRESALE_PACK) ||
                            filters.state.tokenTypes[0] === TokenType.CHEST)) return [3 /*break*/, 4];
                        return [4 /*yield*/, gqlSdk.CardChestBulkMintPreview({ input: { chestsUuids: selectedUuids, timestamp: timestamp } })];
                    case 3:
                        result = _a.sent();
                        setFreeMintsAmount(result.cardChestBulkMintPreview.priceInFreeMint);
                        setCtaTokenAmount(result.cardChestBulkMintPreview.priceInCtaTokenDeci18);
                        return [3 /*break*/, 5];
                    case 4:
                        setFreeMintsAmount(0);
                        setCtaTokenAmount('0');
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function showMintDialog() {
        var _a, _b;
        var ctaTokenDetails = parseCurrencyQuantity("".concat(ctaTokenAmount, "00000000"), appEnv.ctaTokenAddress);
        setDialogProps({
            common: {
                title: t('common.confirm-mint'),
                close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                actions: [{ highlighted: true, text: t('common.confirm'), action: confirmMint }],
            },
            custom: {
                type: DialogType.MINT_MULTIPLE,
                assetsCount: selectedUuids.length,
                freeMintsAmount: freeMintsAmount,
                price: {
                    tokenSymbol: CurrencyTokenSymbol.CTA,
                    value: ((_a = ctaTokenDetails.base) === null || _a === void 0 ? void 0 : _a.displayValue) || '',
                    usdValue: ((_b = ctaTokenDetails.usd) === null || _b === void 0 ? void 0 : _b.displayValue) || '',
                },
            },
        });
    }
    function confirmMint() {
        return __awaiter(this, void 0, void 0, function () {
            var error, pendingTransfer, result, result, _err_1, _a, transferCompleted, transferResult;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (selectedUuids.length === 0 || notEnoughCurrency || !selectedWallet)
                            return [2 /*return*/];
                        error = undefined;
                        pendingTransfer = undefined;
                        setServerLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        if (!(filters.state.tokenTypes[0] === TokenType.CARD)) return [3 /*break*/, 3];
                        return [4 /*yield*/, gqlSdk.CardBulkMint({ input: { cardsUuids: selectedUuids, timestamp: timestamp } })];
                    case 2:
                        result = _b.sent();
                        pendingTransfer = result.cardBulkMint.pendingCtaTokenTransfer;
                        return [3 /*break*/, 5];
                    case 3:
                        if (!(filters.state.tokenTypes[0] === TokenType.PRESALE_PACK ||
                            filters.state.tokenTypes[0] === TokenType.CHEST)) return [3 /*break*/, 5];
                        return [4 /*yield*/, gqlSdk.CardChestBulkMint({ input: { chestsUuids: selectedUuids, timestamp: timestamp } })];
                    case 4:
                        result = _b.sent();
                        pendingTransfer = result.cardChestBulkMint.pendingCtaTokenTransfer;
                        _b.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        _err_1 = _b.sent();
                        error = t('error.generic');
                        return [3 /*break*/, 7];
                    case 7:
                        if (!pendingTransfer) return [3 /*break*/, 17];
                        _b.label = 8;
                    case 8:
                        _b.trys.push([8, 10, , 11]);
                        return [4 /*yield*/, imx.transferERC20({
                                toAddress: pendingTransfer.recipientWalletAddress,
                                tokenAddress: appEnv.ctaTokenAddress,
                                quantity: "".concat(pendingTransfer.ctaTokenCountToTransferDeci18.toString(), "00000000"),
                                walletFrom: selectedWallet,
                            })];
                    case 9:
                        _b.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        _a = _b.sent();
                        error = t('error.generic');
                        return [3 /*break*/, 11];
                    case 11:
                        if (!!error) return [3 /*break*/, 17];
                        return [4 /*yield*/, gqlSdk.BlockchainPendingCtaTtokenTransferSetDone({
                                input: { pendingCtaTokenTransferUuid: pendingTransfer.uuid },
                            })];
                    case 12:
                        _b.sent();
                        transferCompleted = false;
                        _b.label = 13;
                    case 13: return [4 /*yield*/, gqlSdk.BlockchainPendingCtaTtokenTransferFindOne({
                            input: { pendingCtaTokenTransferUuid: pendingTransfer.uuid },
                        })];
                    case 14:
                        transferResult = _b.sent();
                        transferCompleted =
                            transferResult.blockchainPendingCtaTtokenTransferFindOne.status === ImxPendingBurnStatus.COMPLETED;
                        if (!!transferCompleted) return [3 /*break*/, 16];
                        return [4 /*yield*/, sleep(1000)];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16:
                        if (!transferCompleted) return [3 /*break*/, 13];
                        _b.label = 17;
                    case 17: return [4 /*yield*/, Promise.all([getAssets(true), getBalances(), reconnectUser()])];
                    case 18:
                        _b.sent();
                        setServerLoading(false);
                        setSelectedUuids([]);
                        setLastSelectedIndexes([]);
                        setCtaTokenAmount('0');
                        setFreeMintsAmount(0);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('mint.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showBuyFreeMintDialog() {
        setDialogProps({
            common: {
                title: t('mint.buy-free-mints.title'),
                actions: [{ highlighted: true, text: t('common.confirm'), action: buyFreeMints }],
                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
            },
            custom: {
                type: DialogType.BUY_FREE_MINT,
                count: vouchersCount,
            },
        });
    }
    function buyFreeMints() {
        return __awaiter(this, void 0, void 0, function () {
            var error, result, pendingBurnUuid, blockchainPendingBurnFindOneWithEmail, _a, magicLink, metamask, mpc, burnCompleted, burnResult, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setImxLoading(true);
                        error = undefined;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 15, , 16]);
                        return [4 /*yield*/, gqlSdk.PresaleBuyFreeMint()];
                    case 2:
                        result = _c.sent();
                        pendingBurnUuid = result.presaleBuyFreeMint.pendingBurnUuid;
                        return [4 /*yield*/, gqlSdk.BlockchainPendingBurnFindOneWithEmail({
                                input: { pendingBurnUuid: pendingBurnUuid },
                            })];
                    case 3:
                        blockchainPendingBurnFindOneWithEmail = (_c.sent()).blockchainPendingBurnFindOneWithEmail;
                        _a = splitPendingBurns(blockchainPendingBurnFindOneWithEmail.pendingBurn.tokenIdsToBurn), magicLink = _a.magicLink, metamask = _a.metamask, mpc = _a.mpc;
                        if (!(magicLink.ids.length > 0)) return [3 /*break*/, 5];
                        return [4 /*yield*/, burnPendingBurn(imx, magicLink.address, magicLink.ids, WalletConnectionType.MAGIC_LINK, (user === null || user === void 0 ? void 0 : user.email) || '', (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || undefined)];
                    case 4:
                        _c.sent();
                        _c.label = 5;
                    case 5:
                        if (!(metamask.ids.length > 0)) return [3 /*break*/, 7];
                        return [4 /*yield*/, burnPendingBurn(imx, metamask.address, metamask.ids, WalletConnectionType.METAMASK, (user === null || user === void 0 ? void 0 : user.email) || '', (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || undefined)];
                    case 6:
                        _c.sent();
                        _c.label = 7;
                    case 7:
                        if (!(mpc.ids.length > 0)) return [3 /*break*/, 9];
                        return [4 /*yield*/, burnPendingBurn(imx, mpc.address, mpc.ids, WalletConnectionType.MPC, (user === null || user === void 0 ? void 0 : user.email) || '', (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || undefined)];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        burnCompleted = false;
                        _c.label = 10;
                    case 10: return [4 /*yield*/, gqlSdk.BlockchainPendingBurnFindOne({
                            input: { pendingBurnUuid: blockchainPendingBurnFindOneWithEmail.pendingBurn.uuid },
                        })];
                    case 11:
                        burnResult = _c.sent();
                        burnCompleted = burnResult.blockchainPendingBurnFindOne.status === ImxPendingBurnStatus.COMPLETED;
                        if (!!burnCompleted) return [3 /*break*/, 13];
                        return [4 /*yield*/, sleep(1000)];
                    case 12:
                        _c.sent();
                        _c.label = 13;
                    case 13:
                        if (!burnCompleted) return [3 /*break*/, 10];
                        _c.label = 14;
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        _b = _c.sent();
                        error = t('error.generic');
                        return [3 /*break*/, 16];
                    case 16: return [4 /*yield*/, Promise.all([getVouchersCount(), reconnectUser()])];
                    case 17:
                        _c.sent();
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('mint.buy-free-mints.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function getShredPreview() {
        return __awaiter(this, void 0, void 0, function () {
            var shredDisabled, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shredDisabled = isShredDisabled();
                        if (selectedUuids.length === 0 || selectedUuids.length > MAX_SELECTION_COUNT || shredDisabled) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, gqlSdk.CardDisenchantCardsPreview({
                                input: {
                                    cardUuids: selectedUuids,
                                    tokenIds: [],
                                },
                            })];
                    case 1:
                        result = _a.sent();
                        setTriselsCount(result.cardDisenchantCardsPreview.freeGemsCount);
                        setStonesCount(result.cardDisenchantCardsPreview.stoneEternal);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showShredDialog() {
        setDialogProps({
            common: {
                title: t('common.shred'),
                close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                actions: [{ highlighted: true, text: t('common.confirm'), action: confirmShred }],
            },
            custom: {
                type: DialogType.SHRED,
                stonesCount: stonesCount,
                triselsCount: triselsCount,
                multiple: true,
            },
        });
    }
    function confirmShred() {
        return __awaiter(this, void 0, void 0, function () {
            var error, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (selectedUuids.length === 0) {
                            return [2 /*return*/];
                        }
                        setServerLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, gqlSdk.CardDisenchantCards({
                                input: {
                                    cardUuids: selectedUuids,
                                    tokenIds: [],
                                },
                            })];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        error = t('error.generic');
                        return [3 /*break*/, 4];
                    case 4: return [4 /*yield*/, sleep(1000)];
                    case 5:
                        _b.sent();
                        return [4 /*yield*/, Promise.all([getAssets(true), reconnectUser()])];
                    case 6:
                        _b.sent();
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('shred.multiple.success-message'),
                            },
                        });
                        setServerLoading(false);
                        setSelectedUuids([]);
                        setLastSelectedIndexes([]);
                        return [2 /*return*/];
                }
            });
        });
    }
    function isShredDisabled() {
        if (filters.state.tokenTypes[0] !== TokenType.CARD || !cards)
            return true;
        return selectedUuids.some(function (uuid) {
            var card = cards.find(function (card) { return card.uuid === uuid; });
            return card ? card.rarity === CardRarity.EXCLUSIVE || card.rarity === CardRarity.UNIQUE : true;
        });
    }
    return {
        filters: filters,
        cards: cards,
        presalePacks: presalePacks,
        chests: chests,
        maxCountToSelect: maxCountToSelect,
        ctaTokenAmount: ctaTokenAmount,
        freeMintsAmount: freeMintsAmount,
        notEnoughCurrency: notEnoughCurrency,
        previewLoading: previewLoading,
        vouchersCount: vouchersCount,
        selectedUuids: selectedUuids,
        shredDisabled: isShredDisabled(),
        getAssets: getAssets,
        setSelectedUuids: setSelectedUuids,
        selectUuid: selectUuid,
        shiftSelectAsset: shiftSelectAsset,
        changeAssetsSelection: changeAssetsSelection,
        showMintDialog: showMintDialog,
        showBuyFreeMintDialog: showBuyFreeMintDialog,
        showShredDialog: showShredDialog,
    };
}
